<template lang="pug">
div
  PriceInfo(v-if="isPriceInfo")
  MobileSalePoint(v-else-if="isGroundSeller")
  .salepoint-container(v-else)
    sale-toolbar(ref="toolbar")
    dte-selector
    v-card.px-3.py-3.salespoint-card
      .display-area.grey.lighten-1
        router-view
      v-layout(row wrap).mt-2.totals-area
        v-flex.xs12
          sale-totals
      v-layout(row wrap).mt-2.controls-area
        v-flex.xs12
          sale-controls(ref="controls")
    v-progress-circular.main-spinner(indeterminate v-if="showSpinner" :color="colors.complement" size="100" width="10")
    snackbar-modal
    internal-code-search-modal(
      v-model="_showInternalCodeSearch"
      @mode:multi="setShowMultiSelectSearch(true)"
    )
    multi-select-search-modal(
      v-model="_showMultiSelectSearch"
      @mode:quick="setShowInternalCodeSearch(true)"
    )
    //TestingDialog
</template>

<script>
/**
 * Layout Component of the Sale Point
 */
import SaleControls from '@/components/SalePoint/SaleControls/SaleControls'
import SaleTotals from '@/components/SalePoint/SaleTotals/SaleTotals'
import SaleToolbar from '@/components/SalePoint/SaleToolbar/SaleToolbar'
import SnackbarModal from '@/components/SnackbarModal/SnackbarModal'
import KeyBinds from '@/mixins/KeyBinds'
import DTESelector from '@/components/SalePoint/DTESelector/DTESelector'
import { mapActions, mapGetters, mapState } from 'vuex'
import MobileSalePoint from '../Mobile/MobileSalePoint'
import PriceInfo from '../PriceInfo/PriceInfo'
import {
    SearchTypeModal,
    InternalCodeSearchModal,
    MultiSelectSearchModal,
    TestingDialog,
} from '@/components/Search'
import PromoService from '@/services/API/PromoService'
import { getAndSaveLoginToken } from '@/services/auth/AuthService'
import GUser from '@/models/General/GUser'
export default {
    name: 'sale-point',
    props: {},
    data: function() {
        return {
            bindings: {
                f1: () => {
                    if (this.activeSearchModals) return
                    let route = '/'
                    if (this.activeTransaction.id == 6) route = '/cambio'
                    this.$router.replace(route)
                },
                f2: () => {
                    if (
                        this.$route.path !== '/' &&
                        this.$route.path !== '/cambio'
                    )
                        return
                    if (this.activeSearchModals) return
                    this.setShowInternalCodeSearch(true)
                },
                // f3: () => {
                //     this.switchTransactionType()
                // },
                f4: () => {
                    if (this.showInternalCodeSearch) return
                    if ([4, 5].includes(this.activeTransaction.id)) {
                        this.$router.replace('/employee')
                        return
                    }
                    this.$router.replace('/cliente')
                },
                f5: () => {
                    if (this.activeSearchModals) return
                    this.$router.replace(
                        this.isCallCenter ? '/solicitudes_despacho' : '/promos'
                    )
                },
                f8: () => {
                    if (this.activeSearchModals) return
                    this.$refs.controls.$refs.submit.$el.click()
                },
                f11: () => {
                    if (this.activeSearchModals) return
                    this.$router.replace('/reimprimir')
                },
                // f12: () => {
                //     document.getElementById('btn-abort').click()
                // },
            },
        }
    },
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
            activeSearchModals: 'activeSearchModals',
        }),
        ...mapGetters('AuthModule', {
            isGroundSeller: 'isGroundSeller',
            isCallCenter: 'isCallCenter',
            isAuthenticated: 'isAuthenticated',
            isPriceInfo: 'isPriceInfo',
        }),
        ...mapState('AuthModule', ['user']),
        ...mapState('SpinnerModule', {
            showSpinner: 'showSpinner',
        }),
        ...mapState('TransactionModule', {
            showSearchType: 'showSearchType',
            showInternalCodeSearch: 'showInternalCodeSearch',
            showMultiSelectSearch: 'showMultiSelectSearch',
        }),
        /**
         * @description
         */
        _showSearchType: {
            get: function() {
                return this.showSearchType
            },
            set: function(val) {
                this.setShowSearchTpype(val)
            },
        },
        /**
         * @description
         */
        _showInternalCodeSearch: {
            get: function() {
                return this.showInternalCodeSearch
            },
            set: function(val) {
                this.setShowInternalCodeSearch(val)
            },
        },
        /**
         * @description
         */
        _showMultiSelectSearch: {
            get: function() {
                return this.showMultiSelectSearch
            },
            set: function(val) {
                this.setShowMultiSelectSearch(val)
            },
        },
    },
    methods: {
        ...mapActions('TransactionModule', {
            switchTransactionType: 'switchTransactionType',
            setShowSearchTpype: 'setShowSearchType',
            setShowInternalCodeSearch: 'setShowInternalCodeSearch',
            setShowMultiSelectSearch: 'setShowMultiSelectSearch',
            setTransactionType: 'setTransactionType',
        }),
        ...mapActions('PromoModule', {
            resetState: 'resetState',
        }),
        ...mapActions('SessionModule', {
            initCommunes: 'initCommunes',
            initCoreBusinessList: 'initCoreBusinessList',
            initCompanyData: 'initCompanyData',
            fetchCustomerCreditOptions: 'fetchCustomerCreditOptions',
            fetchPchPaymentConditions: 'fetchPchPaymentConditions',
        }),
        test(e) {},
        showSearchModal(e) {
            if (e === 1) this._showInternalCodeSearch = true
            if (e === 2) this._showMultiSelectSearch = true
        },
        abortButtonBind() {
            window.addEventListener('keydown', e => {
                if (e.ctrlKey && e.altKey && e.key === 'F10')
                    window.location.reload(true)
            })
        },
    },
    watch: {
        /**
         * @description
         */
        activeTransaction: function(newVal, oldVal) {
            if ([4, 5].includes(newVal.id) && this.$route.path === '/cliente')
                this.$router.replace('/employee')
            if (![4, 5].includes(newVal.id) && this.$route.path === '/employee')
                this.$router.replace('cliente')
        },
    },
    components: {
        'sale-toolbar': SaleToolbar,
        'sale-controls': SaleControls,
        'sale-totals': SaleTotals,
        'dte-selector': DTESelector,
        'snackbar-modal': SnackbarModal,
        'search-type-modal': SearchTypeModal,
        'internal-code-search-modal': InternalCodeSearchModal,
        'multi-select-search-modal': MultiSelectSearchModal,
        TestingDialog,
        MobileSalePoint,
        PriceInfo,
    },
    mixins: [KeyBinds],
    filters: {},
    // Lifecycle Methods
    //
    beforeCreate: function() {
        getAndSaveLoginToken()
    },
    created: function() {
        this.abortButtonBind()
        if (!this.isGroundSeller) {
            if (!this.isAuthenticated) {
                setTimeout(
                    () =>
                        PromoService.fetchWithModel().then(response => {
                            this.resetState({
                                data: response.response.data,
                                model: response.model,
                                pagination: {
                                    lastPage: response.response.last_page,
                                    currentPage: response.response.current_page,
                                },
                            })
                        }),
                    200
                )
            } else {
                PromoService.fetchWithModel().then(response => {
                    this.resetState({
                        data: response.response.data,
                        model: response.model,
                        pagination: {
                            lastPage: response.response.last_page,
                            currentPage: response.response.current_page,
                        },
                    })
                })
            }
        }
        this.initCommunes()
        this.initCompanyData()
        this.initCoreBusinessList()
        this.fetchCustomerCreditOptions()
        this.fetchPchPaymentConditions()
        if (this.isGroundSeller) {
            this.setTransactionType(2)
        }
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.salepoint-container {
    max-width: 100vw;
    max-height: 100vh;
    overflow: hidden;
}
.salespoint-card {
    height: calc(100vh - 68px);
    overflow: hidden;
    .display-area {
        height: calc(100vh - 215px);
        overflow-y: auto;
    }
    .controls-area {
        height: 100px;
    }
    .totals-area {
        height: 50px;
    }
}
.main-spinner {
    position: fixed;
    top: calc(50vh - 50px);
    left: calc(50vw - 50px);
}
</style>
